<template>
  <div class="card shadow border-0" v-if="content">
    <img class="card-img-top" :src="content.img.src" :alt="content.img.alt">
    <div class="card-body">
      <div class="pt-4">
        <div class="card-block pl-1 pr-2">
          <h3 class="card-text mb-3 ml-4 text-muted">{{content.title}}</h3>
          <vue-markdown class="card-text mb-3 ml-4 text-muted">{{content.text}}</vue-markdown>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default { props: ['content'] }
</script>
